import React, { useCallback } from 'react';

import ChickenFooter from 'assets/images/footer/chicken-footer.svg';
import Facebook from 'assets/images/footer/facebook.svg';
import Instagram from 'assets/images/footer/instagram.svg';
import Twitter from 'assets/images/footer/twitter.svg';
import Youtube from 'assets/images/footer/youtube.svg';
import firebase from 'services/firebase';
import { openPrivallyModal } from 'utils/privallyUtils';

import { Container, LegalInfo, Links, SocialMedial } from './styles';

function FooterComponent() {
  const handleWatchFirebaseEvents = useCallback(
    tag => {
      firebase.analytics().logEvent('links_rodape', {
        opcao: tag,
      });
    },
    [firebase],
  );

  return (
    <Container>
      <img id="ChickenFooter" src={ChickenFooter} alt="Logo" />
      <SocialMedial>
        <a href="https://www.instagram.com/popeyesbrasil/?hl=pt-br">
          <img src={Instagram} alt="Instagram Decal" />
        </a>
        <a href="https://pt-br.facebook.com/popeyesbrasil/">
          <img src={Facebook} alt="Facebook Decal" />
        </a>
        <a href="https://twitter.com/popeyesbrasil/">
          <img src={Twitter} alt="Twitter Decal" />
        </a>
        <a href="https://www.youtube.com/channel/UC6lMe8Db-hKQUDjDSeIPYCg">
          <img src={Youtube} alt="Youtube Decal" />
        </a>
      </SocialMedial>
      <Links>
        <a
          href="https://play.google.com/store/apps/details?id=com.app.plk"
          onClick={() => handleWatchFirebaseEvents('google_play')}
        >
          APP Popeyes
        </a>
        <a
          href="/enviar-email?isHelp=true"
          onClick={() => handleWatchFirebaseEvents('fale_conosco')}
        >
          Fale com a gente
        </a>
        <a href="/direitos-e-solicitacoes">Direitos e solicitações</a>
        <a href="https://burgerking.riweb.com.br/">Relação com investidores</a>
      </Links>

      <LegalInfo>
        <a href="/politica-de-privacidades?href=/">
          Diretrizes e privacidade de dados
        </a>
        <a href="/termos-de-uso?href=/">Informações legais</a>
        {
          /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
          <a href="#" onClick={openPrivallyModal}>
            Opções de privacidade
          </a>
        }
      </LegalInfo>
    </Container>
  );
}

export default FooterComponent;
